/**
 * USD → SYP (Syrian Lira) rate. Seeded from VITE_SYP_PER_USD, then kept in sync
 * with the admin-editable rate fetched from /api/system/exchange-rate (see App.jsx).
 * Exported as a live `let` binding so existing `import { SYP_PER_USD }` call sites
 * see updates without change.
 */
export let SYP_PER_USD = Number(import.meta.env.VITE_SYP_PER_USD) || 15_000;

export function setSypPerUsd(value) {
  const n = Number(value);
  if (Number.isFinite(n) && n > 0) {
    SYP_PER_USD = n;
  }
}
